import React from "react";
import FeaturedTournament from "./FeaturedTournament";

const FeaturedTournamentContainer: React.FC = () => {
  return <FeaturedTournament />;
};

export default FeaturedTournamentContainer;
